import PropTypes from "prop-types";

import BlockText from "../block-content/block-text";
import styled from "styled-components";
import tw from "twin.macro";
import StandardPageBlock from "./standard-group-single-block";
import Image from "gatsby-plugin-sanity-image";

const PageBlockGroup = ({ pageBlockGroup, section }) => {
  const Intro = styled.div`
    a {
      ${tw`text-blue-500 cursor-pointer underline hover:text-blue-600`}
    }
    p {
      ${tw`text-base md:text-lg mb-6`}
    }
  `;
  return (
    <section className="py-10 md:py-16">
      <div className="max-w-6xl px-4 mx-auto">
        <div className="md:flex md:flex-wrap">
          <div className="w-full md:w-10/12 mx-auto">
            <hr className="w-8 border-yellow-500 border-4 mb-1 md:mb-2" />
            <h2 className="text-blue-500 leading-tighter font-bold tracking-tighter text-2xl md:text-4xl md:mb-3">
              {pageBlockGroup.title}
            </h2>
            {pageBlockGroup.image && pageBlockGroup.image.asset && (
              <Image
                {...pageBlockGroup.image}
                width={736}
                className="align-top"
                alt={pageBlockGroup.image.alt || ``}
              />
            )}
            <Intro>
              {pageBlockGroup._rawBody && (
                <BlockText blocks={pageBlockGroup._rawBody} section={section} />
              )}
            </Intro>
          </div>
        </div>
      </div>
      <div className="max-w-6xl px-4 mx-auto">
        {pageBlockGroup.pageBlocks &&
          pageBlockGroup.pageBlocks.map((pageBlock) => (
            <StandardPageBlock
              pageBlock={pageBlock}
              key={pageBlock._key}
              section={section}
            />
          ))}
      </div>
    </section>
  );
};

PageBlockGroup.propTypes = {
  title: PropTypes.string,
};

export default PageBlockGroup;
